module.exports = __webpack_public_path__ + "content/5a3a31c631d2746452ea5cc8af09885b.svg";